import React from 'react';
import './info.sass';
import './../../../quotes/quotes.sass';
import { Line } from '../../../line/line';

import { InfoMapMap } from './infoMap';

import { InfoSliderss } from './infoSliderss';  // -------------ДОДЕЛАТЬ------------------
import { Quotes } from '../../../quotes/quotes';

export const Info = () => { 
    return( 
        <>
            <div className = "Info_about_me">
                <div>
                    {/* Info */}
                    <h2 id = "Info_about_me_h2">Обо мне</h2>
                    <Line />
                </div>
                
                <div className = "Info_about_me_text_all adaptivnost_otstupov">
                    <p className = "Info_about_me_text">Мои преимущества: </p>
                </div>    
            
                <div className = "infoAboutMeBlocks">
                    <InfoMapMap />
                </div>
    
                <div className = "Info_about_me_text_all adaptivnost_otstupov">
                    <p className = "Info_about_me_text">Что умею: </p>
                </div>    
                <p  id="infoBot">
                    писать ботов для Discord и Telegram на python, сайты, игры.
                </p>

                <InfoSliderss />
                
            </div>
            <div className="quotesInfo">
                <Quotes text="Измерять продуктивность программиста подсчетом строк кода — это так же, как оценивать постройку самолета по его весу."
                author="«Bill Gates»"/> 
            </div>
        </>
    )
}